import React from 'react';

class LandingPricing extends React.Component {
  render() {
    return (
      <div id="landing-pricing-text" className="width-limit">
        Our pricing is based on product complexity. We also offer a discounted price for larger
        projects.
        <br />
        <br />
        To get a quote, please reach out to us with the form below and we shall give an estimate for
        your requirements at the earliest.
      </div>
    );
  }
}

export default LandingPricing;
